if (!customElements.get('added-notification')) {
  const AddedNotification = class extends HTMLElement {
    connectedCallback() {
      this.dismissOthers();
      this.populate();
      this.display();
    }

    disconnectedCallback() {
      clearTimeout(this.delayedDismissTimeout);
    }

    dismissOthers() {
      document.querySelectorAll('.added-notification').forEach((notification) => {
        if (notification !== this) {
          notification.dismiss();
        }
      });
    }

    populate() {
      const { productTitle, productVariant, productQty, productImage, productImageAlt, cartCount } = this.dataset;

      const titleEl = this.querySelector('.added-notification__message-title');
      if (titleEl) titleEl.innerText = productTitle || '';

      const variantEl = this.querySelector('.added-notification__product-variant');
      if (variantEl) {
        if (productVariant && productVariant !== 'Default Title') {
          variantEl.innerText = productVariant;
        } else {
          variantEl.style.display = 'none';
        }
      }

      const qtyEl = this.querySelector('.added-notification__qty-value');
      if (qtyEl) qtyEl.innerText = productQty || '1';

      const imgEl = this.querySelector('.added-notification__img');
      if (imgEl) {
        if (productImage) {
          imgEl.src = productImage;
          imgEl.alt = productImageAlt || productTitle || '';
        } else {
          const imgWrapper = this.querySelector('.added-notification__product-image');
          if (imgWrapper) imgWrapper.style.display = 'none';
        }
      }

      const countEl = this.querySelector('.added-notification__cart-count');
      if (countEl && cartCount) countEl.innerText = cartCount;
    }

    display() {
      setTimeout(() => this.classList.remove('added-notification--hidden'), 10);

      this.delayedDismissTimeout = setTimeout(this.dismiss.bind(this), 8000);

      this.querySelector('.added-notification__close').addEventListener('click', this.dismiss.bind(this));

      if (theme.settings.cartType === 'drawer') {
        const cartBtn = this.querySelector('.added-notification__view-cart');
        if (cartBtn) {
          cartBtn.addEventListener('click', (evt) => {
            evt.preventDefault();
            document.querySelector('.js-cart-drawer').open(evt.currentTarget);
            this.dismiss();
          });
        }
      }

      const continueLink = this.querySelector('.added-notification__continue');
      if (continueLink) {
        continueLink.addEventListener('click', this.dismiss.bind(this));
      }
    }

    dismiss(evt) {
      if (evt) { evt.preventDefault(); }
      this.classList.add('added-notification--dismissed');
      setTimeout(this.remove.bind(this), 2000);
    }
  };

  window.customElements.define('added-notification', AddedNotification);
}
